<div class="filter-wraper">
    <div class="container">
        <div class="row">
            <div class="col-12 text-right mb-3">
                <span class="close-btn">
                    <img src="assets/icon/clear.svg" class="close" alt="close" (click)="closeSheet();crossBtnGA()">
                </span>
            </div>
            <div class="col-6 col-md-6 pb-2">
                <h2 class="filter">
                    Filter By
                </h2>
            </div>
            <div class="col-6 col-md-6 pb-2 text-right set-text">
                <p (click)= "setTodefault()">SET TO DEFAULT</p>
            </div>
        </div>
    </div>
    <!-- <hr> -->
    <div class="coffee-tags">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <!-- <div class="list" *ngFor="let item of data.subCategoriesMenuList" 
                    [ngClass]="{display_item: item.filtersData != null,
                    'display_not': item.filtersData == null}">
                           <h4 *ngIf="item.filtersData != null">{{item.name}}</h4>
                            <span
                            class="badge badge-secondary"
                             (click)="selectedItem(item1,index)"
                             *ngFor="let item1 of item.filtersData;let index = index"
                             [ngClass]="{background_Selected: item1['click'] == true,
                              'background_unSelected':item1['click'] == false}"
                             >
                            {{item1.tag}}
                             </span>
                    </div> -->
                    <div class="list" *ngFor="let item of data.subCategoriesMenuList" >
                    <div  *ngIf="item.filtersData != null && item.filtersData[0].tag != ''"
                    [ngClass]="{display_item: item.filtersData != null,
                        'display_not': item.filtersData == null}">
                        <h4 *ngIf="item.filtersData != null">{{item.name}}</h4>
                        <span
                        class="badge badge-secondary"
                         (click)="selectedItem(item1,index)"
                         *ngFor="let item1 of item.filtersData;let index = index"
                         [ngClass]="{background_Selected: item1['click'] == true,
                          'background_unSelected':item1['click'] == false}"
                         >
                        <span *ngIf="item1.tag !=''">{{item1.tag}}</span>
                         </span>
                    </div>
                           
                    </div>
                </div>
                <!-- <div class="col-12">
                    <div class="list" *ngFor="let item of list">
                           <h4>{{item.category}}</h4>
                           <span [ngClass]="{background_Selected: item1['click'] == true,
                              'background_unSelected':item1['click'] == false}" class="badge badge-secondary" (click)="selectedItem(item1,index)" *ngFor="let item1 of item.tagsTypes;let index = index">
                              {{item1.name}}
                               </span>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>
